(function () {
    window.gbg = window.gbg || {};
    gbg.Report = (function () {
        const logos = [
            {
                svg: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.72 0H1.28C0.572 0 0 0.572 0 1.28V30.72C0 31.428 0.572 32 1.28 32H30.72C31.428 32 32 31.428 32 30.72V1.28C32 0.572 31.428 0 30.72 0ZM9.492 27.268H4.744V11.996H9.492V27.268ZM7.12 9.908C6.57571 9.908 6.04363 9.7466 5.59107 9.4442C5.13851 9.14181 4.78578 8.71201 4.57748 8.20914C4.36919 7.70628 4.31469 7.15295 4.42088 6.61911C4.52707 6.08528 4.78917 5.59492 5.17404 5.21004C5.55892 4.82517 6.04928 4.56307 6.58311 4.45688C7.11695 4.35069 7.67028 4.40519 8.17314 4.61348C8.67601 4.82178 9.10581 5.17451 9.4082 5.62707C9.7106 6.07963 9.872 6.61171 9.872 7.156C9.868 8.676 8.636 9.908 7.12 9.908ZM27.268 27.268H22.524V19.84C22.524 18.068 22.492 15.792 20.056 15.792C17.588 15.792 17.208 17.72 17.208 19.712V27.268H12.468V11.996H17.02V14.084H17.084C17.716 12.884 19.264 11.616 21.576 11.616C26.384 11.616 27.268 14.78 27.268 18.892V27.268Z" fill="white" /></svg>',
                link: 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A//gbgplc.com/the-global-fraud-report-2024/'
            },
            {
                svg: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895431 0 0 0.895431 0 2V30C0 31.1046 0.895431 32 2 32H30C31.1046 32 32 31.1046 32 30V2C32 0.895431 31.1046 0 30 0H2ZM24.2525 7.2L17.9983 14.6524H17.9979L24.8 24.8H19.7974L15.2169 17.9666L9.48212 24.8H8L14.5589 16.985L8 7.2H13.0026L17.3399 13.6708L22.7704 7.2H24.2525ZM15.3038 16.0969L15.9683 17.0712V17.0716L20.4947 23.7083H22.7711L17.2243 15.5751L16.5598 14.6007L12.2926 8.34372H10.0162L15.3038 16.0969Z" fill="white" /></svg>',
                link: 'https://twitter.com/intent/tweet?text=https%3A//gbgplc.com/the-global-fraud-report-2024/'
            },
            {
                svg: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895431 0 0 0.895431 0 2V30C0 31.1046 0.895431 32 2 32H30C31.1046 32 32 31.1046 32 30V2C32 0.895431 31.1046 0 30 0H2ZM6 8.25C5.58579 8.25 5.25 8.58579 5.25 9V23C5.25 23.4142 5.58579 23.75 6 23.75H26C26.4142 23.75 26.75 23.4142 26.75 23V9C26.75 8.58579 26.4142 8.25 26 8.25H6ZM16 16.5157L8.04039 9.75H23.9596L16 16.5157ZM16.4857 18.0715L25.25 10.6218V21.3987L20.4801 17.4238C20.1619 17.1587 19.689 17.2017 19.4238 17.5199C19.1587 17.8381 19.2017 18.311 19.5199 18.5762L23.9285 22.25H8.07154L12.4801 18.5762C12.7983 18.311 12.8413 17.8381 12.5762 17.5199C12.311 17.2017 11.8381 17.1587 11.5199 17.4238L6.75 21.3987V10.6218L15.5143 18.0715C15.7943 18.3095 16.2057 18.3095 16.4857 18.0715Z" fill="white" /></svg>',
                link: 'mailto:?subject=The%20Global%20Fraud%20Report%202024'
            }
        ];

        // Function to add logos with links to the section
        function addLogos() {
            const logoSections = document.getElementsByClassName('nav-search-container');

            // Ensure that elements with the class name exist
            if (logoSections.length > 0) {
                const logoSection = logoSections[0]; // Use the first element with this class

                // Create a div element to wrap all logos
                const logoContainer = document.createElement('span');
                logoContainer.classList.add('logo-container'); // Adding a class for styling

                logos.forEach(logo => {
                    // Create an anchor element
                    const anchor = document.createElement('a');
                    anchor.href = logo.link;
                    anchor.target = '_blank'; // Optional: Open link in a new tab

                    // Create a div to hold the SVG
                    const svgWrapper = document.createElement('span');
                    svgWrapper.classList.add('svg-logo'); // Optional: Add a class for styling
                    svgWrapper.innerHTML = logo.svg; // Set the SVG markup as the inner HTML

                    // Append the SVG wrapper to the anchor
                    anchor.appendChild(svgWrapper);

                    // Append the anchor to the logo container
                    logoContainer.appendChild(anchor);
                });

                const button = document.createElement('a');
                button.id = 'copyButton';
                button.innerHTML = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895431 0 0 0.895431 0 2V30C0 31.1046 0.895431 32 2 32H30C31.1046 32 32 31.1046 32 30V2C32 0.895431 31.1046 0 30 0H2ZM16.2025 7.68092L14.1734 9.70997C15.6344 9.54764 16.676 9.91287 17.0142 10.1158L17.8258 9.30416C19.1706 7.95942 21.3509 7.95942 22.6957 9.30416C24.0405 10.6489 24.0405 12.8291 22.6957 14.1739L19.8549 17.0145C18.5101 18.3593 16.3298 18.3593 14.985 17.0145L14.1734 16.2029L12.5501 17.8262L13.3617 18.6378C15.603 20.879 19.2369 20.879 21.4782 18.6378L24.319 15.7971C26.5603 13.5559 26.5603 9.92214 24.319 7.68092C22.0777 5.43969 18.4438 5.43969 16.2025 7.68092ZM15.7975 24.3191L17.8266 22.29C16.3656 22.4524 15.324 22.0871 14.9858 21.8842L14.1742 22.6958C12.8294 24.0406 10.6491 24.0406 9.30429 22.6958C7.9595 21.3511 7.9595 19.1709 9.30429 17.8261L12.1451 14.9855C13.4899 13.6407 15.6702 13.6407 17.015 14.9855L17.8266 15.7971L19.4499 14.1738L18.6383 13.3622C16.397 11.121 12.7631 11.121 10.5218 13.3622L7.68098 16.2029C5.43967 18.4441 5.43967 22.0779 7.68098 24.3191C9.9223 26.5603 13.5562 26.5603 15.7975 24.3191Z" fill="white" /></svg >';

                logoContainer.appendChild(button);

                // Prepend the logo container to the logo section
                logoSection.insertBefore(logoContainer, logoSection.firstChild);
            }
        }

        function copyLink() {
            document.getElementById('copyButton').addEventListener('click', function () {
                const url = window.location.href;
                navigator.clipboard.writeText(url).then(function () {
                    //alert('URL copied to clipboard: ' + url);
                }).catch(function (error) {
                    //console.error('Failed to copy text: ', error);
                });
            });
        }

        let timing = 8000;
        let currentChart = 0;
        let chartSlideshow, chartSlideshowChart,
            chartSlideshowChartValues, chartSlideshowChartTextItems,
            chartSlideshowChartsCount;

        let init = function () {
            chartSlideshow = document.querySelector('.chart-slideshow');
            chartSlideshowChart = document.querySelector('.chart-slideshow__chart');
            chartSlideshowChartValues = document.querySelectorAll('.chart-slideshow__chart div');
            chartSlideshowChartTextItems = document.querySelectorAll('.chart-slideshow__text p');
            chartSlideshowChartsCount = chartSlideshowChartValues.length;
            let currentValue = chartSlideshowChartValues[0].dataset.percent;
            chartSlideshowChart.style.setProperty('--p', currentValue);

            timing = chartSlideshow.dataset.timing * 1000;

            setTimeout(nextChart, timing);
            addLogos();
            copyLink();
        };

        function nextChart() {
            currentChart++;
            if (currentChart > chartSlideshowChartsCount - 1) currentChart = 0;

            chartSlideshow.dataset.activeslide = currentChart;
            let currentValue = chartSlideshowChartValues[currentChart].dataset.percent;
            chartSlideshowChart.style.setProperty('--p', currentValue);
            chartSlideshowChart.classList.add('chart-slideshow__chart--animate-b');
            setTimeout(function () { chartSlideshowChart.classList.remove('chart-slideshow__chart--animate-b'); }, 600);

            chartSlideshowChartValues.forEach((t) => {
                t.classList.remove('active');
            });
            chartSlideshowChartValues[currentChart].classList.add('active');

            chartSlideshowChartTextItems.forEach((i) => {
                i.classList.remove('active');
            });
            chartSlideshowChartTextItems[currentChart].classList.add('active');

            setTimeout(nextChart, timing);
        }

        return {
            init: init
        };

    }());

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", gbg.Report.init);
    } else {
        gbg.Report.init();
    }

}());